/**
 * @purpose To replace +61 with 0
 * @param phone Users's phone returned from the db
 */
export const transformPhoneNumber = (phone: string) => {
  const replaceCountryCode = phone?.replace('+61', '0');
  if(replaceCountryCode.charAt(0) !== '0') return `0${replaceCountryCode}`;
  return  replaceCountryCode;
};